export default {
  'component.global.search': 'Search',
};

